import { motion } from "framer-motion";

const FEATURES = [
    {
        title: "Strategic Location in Malaysia",
        body: "Malaysia provides a strong regional base for international trade, halal industry access and commercial connectivity.",
    },
    {
        title: "Extensive International Network",
        body: "We build supplier, logistics, distribution and buyer relationships across key global trade regions.",
    },
    {
        title: "Flexible Asset-Light Business Model",
        body: "Our scalable operating model allows faster response, efficient coordination and competitive trade execution.",
    },
    {
        title: "Global Trade Expertise",
        body: "Quality, compliance, reliability, customer focus and long-term partnerships guide every market relationship.",
    },
];

export const WhyUs = () => {
    return (
        <section
            id="why-us"
            data-testid="why-us-section"
            className="relative bg-[#0B0807]/82 backdrop-blur-md py-24 sm:py-32 lg:py-40 px-4 sm:px-8 lg:px-12 border-t border-white/5"
        >
            <div className="flex items-center gap-3 font-mono-text text-[10px] sm:text-xs uppercase tracking-[0.3em] text-zinc-500 mb-6">
                <span className="h-px w-10 bg-[#D69331]" />
                <span>03 / Why DUHA</span>
            </div>

            <motion.h2
                initial={{ y: 60, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                className="font-display uppercase font-bold leading-[0.9] tracking-tight text-white text-4xl sm:text-6xl lg:text-7xl max-w-5xl"
            >
                Your trusted partner for{" "}
                <span className="text-zinc-600">
                    international trade & global supply chain.
                </span>
            </motion.h2>

            <p className="mt-8 font-mono-text text-sm sm:text-base text-zinc-400 leading-relaxed max-w-3xl">
                In today's rapidly evolving global economy, businesses require
                more than suppliers and distributors. They require strategic
                partners capable of navigating international markets, managing
                complex supply chains and creating sustainable growth
                opportunities.
            </p>

            <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-px bg-zinc-900 border border-zinc-900">
                {FEATURES.map((f, i) => (
                    <motion.div
                        key={f.title}
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-50px" }}
                        transition={{
                            duration: 0.6,
                            delay: i * 0.08,
                            ease: [0.16, 1, 0.3, 1],
                        }}
                        className="group bg-[#0a0a0a] hover:bg-[#0f0f0f] transition-colors duration-300 p-8 sm:p-10 lg:p-12 flex flex-col gap-6 min-h-[280px]"
                    >
                        <div className="flex items-center justify-between">
                            <span className="font-mono-text text-[10px] uppercase tracking-[0.3em] text-zinc-500">
                                {String(i + 1).padStart(2, "0")} / Advantage
                            </span>
                            <span className="h-2 w-2 bg-zinc-700 group-hover:bg-[#D69331] transition-colors" />
                        </div>

                        <h3 className="font-display uppercase text-2xl sm:text-3xl lg:text-4xl font-semibold leading-tight text-white">
                            {f.title}
                        </h3>

                        <p className="font-mono-text text-sm sm:text-base text-zinc-400 leading-relaxed mt-auto">
                            {f.body}
                        </p>
                    </motion.div>
                ))}
            </div>
        </section>
    );
};
